import React, { useEffect, useState } from "react";
import { ListGroup } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SplitPane from "react-split-pane";
import { studyEventFormSchemaServices } from "../../../../../APIServices/studyEventFormSchemaServices";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import ViewSchemaFormReportList from "./ViewSchemaFormReportList";

const SchemaReport = () => {
  const [schemaList, setSchemaList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [schemaId, setSchemaId] = useState("");
  const [schemaName, setSchemaName] = useState("");
  const [formData, setFormData] = useState([]);
  const [reportLoader, setReportLoader] = useState(false);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getEventFormSchema = async () => {
    setLoading(true);
    let data = await studyEventFormSchemaServices.getEventFormSchema(
      "active",
      studyId
    );
    setSchemaList(data?.data || []);
    setLoading(false);
  };

  const getFormReportBasedonSchema = async () => {
    setReportLoader(true);
    let data =
      await await studyEventFormSchemaServices.getFormReportBasedonSchema(
        studyId,
        schemaId,
        StudyMode
      );
    if (data === "AbortError") {
      setReportLoader(true);
    } else {
      setFormData(data?.data || []);
      setReportLoader(false);
    }
  };

  useEffect(() => {
    getEventFormSchema();
  }, [studyId]);

  useEffect(() => {
    if (schemaId && studyId) {
      getFormReportBasedonSchema();
    }
  }, [schemaId, studyId]);

  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"20%"}
        className="position-relative bg-white"
        style={{ height: "calc(100vh - 146px)" }}
      >
        {loading ? (
          <PageLoader />
        ) : schemaList?.length === 0 ? (
          <div className="hstack justify-content-center h-100">
            <NoDataFoundTable MSG={"List not found!"} />
          </div>
        ) : (
          <ListGroup className="p-2">
            {schemaList?.map((schema, index) => (
              <ListGroup.Item
                action
                title={schema?.schemaName}
                onClick={() => {
                  setSchemaId(schema?.schemaId);
                  setSchemaName(schema?.schemaName);
                }}
                key={index}
                style={{ padding: "7px 0px 7px 10px" }}
                className={`hstack ${schemaId === schema?.schemaId ? "selectedMenu" : "bg-white"
                  }`}
              >
                <span>{schema?.schemaName}</span>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
        {reportLoader ? (
          <PageLoader />
        ) : !schemaId ? (
          <NoDataFoundTable MSG={`Click to view Report!`} />
        ) : (
          <ViewSchemaFormReportList
            formData={formData}
            schemaName={schemaName}
          />
        )}
      </SplitPane>
    </>
  );
};

export default SchemaReport;
